
import React from 'react';
import { useAuth } from '../../contexts/AuthContext';

const WelcomeBanner = () => {
  const { updateOnboardingStatus } = useAuth();

  const handleStart = () => {
    updateOnboardingStatus('in_progress');
  };

  const handleSkip = () => {
    updateOnboardingStatus('completed');
  };

  const bannerStyle = {
    backgroundColor: '#f0f7ff',
    border: '1px solid #cce4ff',
    borderRadius: '8px',
    padding: window.innerWidth < 768 ? '24px 16px' : '40px',
    textAlign: 'center',
    margin: window.innerWidth < 768 ? '24px 16px' : '40px auto',
    maxWidth: '800px',
  };

  const buttonStyle = {
    padding: '12px 24px',
    margin: '0 10px',
    borderRadius: '5px',
    border: 'none',
    cursor: 'pointer',
    fontSize: '16px',
    fontWeight: 'bold',
  };

  const primaryButtonStyle = {
    ...buttonStyle,
    backgroundColor: '#007bff',
    color: 'white',
  };

  const secondaryButtonStyle = {
    ...buttonStyle,
    backgroundColor: 'transparent',
    color: '#007bff',
    textDecoration: 'underline',
  };

  return (
    <div style={bannerStyle}>
      <h1 style={{ fontSize: window.innerWidth < 768 ? '22px' : '28px', color: '#003366', marginBottom: '15px', fontWeight: '700' }}>Welcome to SwiftBidPro!</h1>
      <p style={{ fontSize: window.innerWidth < 768 ? '16px' : '18px', color: '#0059b3', marginBottom: '30px', lineHeight: '1.5' }}>Let's get you set up for success.</p>
      <div>
        <button style={primaryButtonStyle} onClick={handleStart}>
          Start Guided Setup
        </button>
        <button style={secondaryButtonStyle} onClick={handleSkip}>
          I'll explore on my own
        </button>
      </div>
    </div>
  );
};

export default WelcomeBanner;
